module.exports = __webpack_public_path__ + "img/bg70.7fc9de09.png";